export default __webpack_public_path__ + "static/media/RENATO_BAGAROLO_Malta_SanMarino.49fec95b.jpg";